/* import __COLOCATED_TEMPLATE__ from './about.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();